(function () {
  'use strict';

  var overlay, imgEl, captionEl, counterEl;
  var images = [];
  var currentIndex = 0;

  function buildOverlay() {
    if (document.getElementById('cp-lightbox')) {
      overlay    = document.getElementById('cp-lightbox');
      imgEl      = overlay.querySelector('.cp-lightbox__img');
      captionEl  = overlay.querySelector('.cp-lightbox__caption');
      counterEl  = overlay.querySelector('.cp-lightbox__counter');
      return;
    }

    overlay = document.createElement('div');
    overlay.id = 'cp-lightbox';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image viewer');

    overlay.innerHTML =
      '<div class="cp-lightbox__backdrop"></div>' +
      '<button class="cp-lightbox__close" aria-label="Close">×</button>' +
      '<button class="cp-lightbox__prev" aria-label="Previous image">‹</button>' +
      '<button class="cp-lightbox__next" aria-label="Next image">›</button>' +
      '<div class="cp-lightbox__content">' +
        '<img class="cp-lightbox__img" src="" alt="">' +
        '<p class="cp-lightbox__caption"></p>' +
        '<p class="cp-lightbox__counter"></p>' +
      '</div>';

    document.body.appendChild(overlay);

    imgEl     = overlay.querySelector('.cp-lightbox__img');
    captionEl = overlay.querySelector('.cp-lightbox__caption');
    counterEl = overlay.querySelector('.cp-lightbox__counter');

    overlay.querySelector('.cp-lightbox__backdrop').addEventListener('click', close);
    overlay.querySelector('.cp-lightbox__close').addEventListener('click', close);
    overlay.querySelector('.cp-lightbox__prev').addEventListener('click', function () { navigate(-1); });
    overlay.querySelector('.cp-lightbox__next').addEventListener('click', function () { navigate(1); });

    document.addEventListener('keydown', function (e) {
      if (overlay.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape')      close();
      if (e.key === 'ArrowLeft')   navigate(-1);
      if (e.key === 'ArrowRight')  navigate(1);
    });
  }

  function open(index, imageList) {
    images = imageList;
    currentIndex = index;
    buildOverlay();
    render();
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function navigate(dir) {
    currentIndex = (currentIndex + dir + images.length) % images.length;
    render();
  }

  function render() {
    var item = images[currentIndex];
    imgEl.src = item.src;
    imgEl.alt = item.title;
    captionEl.textContent = item.title;
    counterEl.textContent = images.length > 1
      ? (currentIndex + 1) + ' / ' + images.length
      : '';

    var showNav = images.length > 1;
    overlay.querySelector('.cp-lightbox__prev').style.display = showNav ? '' : 'none';
    overlay.querySelector('.cp-lightbox__next').style.display = showNav ? '' : 'none';
  }

  function init(container) {
    var triggers = container.querySelectorAll('[data-lightbox-src]');
    if (!triggers.length) return;

    var imageList = Array.prototype.map.call(triggers, function (el) {
      return {
        src:   el.getAttribute('data-lightbox-src'),
        title: el.getAttribute('data-lightbox-title') || ''
      };
    });

    Array.prototype.forEach.call(triggers, function (el, i) {
      el.style.cursor = 'zoom-in';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open(i, imageList);
      });
    });
  }

  // Auto-initialise any containers already in the DOM
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lightbox-container]').forEach(function (container) {
      init(container);
    });
  });

  window.CPLightbox = { init: init };
})();
